import { AudienceSegmentActiveInactive, IAudienceSegment } from '~/src/dash/api/console-api';

export const targetingInactiveAudienceSegments = (
  segments: IAudienceSegment[],
  segmentIDs: string,
): boolean => {
  const ids = segmentIDs.split(',');
  for (const id of ids) {
    for (const segment of segments) {
      if (segment.ID === id && segment.Active === AudienceSegmentActiveInactive) {
        return true;
      }
    }
  }

  return false;
};
